import { types } from "mobx-state-tree";
import { IInput } from "../../utils/common-interface";

const SortModel = types
    .model("SortModel", {
        columnName: types.optional(types.string, ""),
        orderByDescending: types.optional(types.boolean, false),
    })
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));

export const PaginationModel = types
    .model("PaginationModel", {
        searchText: types.optional(types.string, ""),
        pageNo: types.optional(types.number, 1),
        pageSize: types.optional(types.number, 20),
        sortBy: types.maybe(SortModel),
        totalRow: types.optional(types.number, 0),
    })
    .views((self: any) => ({
        get totalPages() {
            return Math.ceil(self.totalRow / self.pageSize);
        },
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));
